import React from 'react';
import PropTypes from 'prop-types';

import { PlatesForPooling, PoolButtons, PooledPlates } from './components';

import './PlatePoolingCustom.style.scss';

const PlatePoolingCustomComponent = ({
  onCheckPlates,
  onAdd,
  onRemove,
  showPoolingScrollBar,
  showPooledscrollBar,
  disableAddButton,
  disableRemoveButton,
  platesForPooling,
  pooledPlates,
  checkedPoolingPlates,
  checkedPooledPlates,
}) => {
  const showPlatesForPooling = !!platesForPooling.length;
  const showPooledPlates = !!pooledPlates.length;

  return (
    <div className="plate-pooling-custom-container">
      <PlatesForPooling
        {...{
          showPlatesForPooling,
          showPoolingScrollBar,
          checkedPoolingPlates,
          platesForPooling,
          onCheckPlates
        }}
      />
      <PoolButtons
        {...{
          onAdd,
          onRemove,
          disableAddButton,
          disableRemoveButton
        }}
      />
      <PooledPlates
        {...{
          showPooledPlates,
          showPooledscrollBar,
          checkedPooledPlates,
          pooledPlates,
          onCheckPlates
        }}
      />
    </div>
  );
};

PlatePoolingCustomComponent.propTypes = {
  onCheckPlates: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  showPoolingScrollBar: PropTypes.bool.isRequired,
  showPooledscrollBar: PropTypes.bool.isRequired,
  disableAddButton: PropTypes.bool.isRequired,
  disableRemoveButton: PropTypes.bool.isRequired,
  platesForPooling: PropTypes.array.isRequired,
  pooledPlates: PropTypes.array.isRequired,
  checkedPooledPlates: PropTypes.array.isRequired,
  checkedPoolingPlates: PropTypes.array.isRequired,
};

export default PlatePoolingCustomComponent;
